export interface FaqItem {
  question: string;
  answer: string;
}

export interface FaqCategory {
  title: string;
  items: FaqItem[];
}

export const faqData: FaqCategory[] = [
  {
    title: 'はじめての方へ',
    items: [
      {
        question: 'RideHubで何ができますか？',
        answer:
          'サイクリスト向けのスポット共有アプリです。ツーリング途中に見つけた絶景ポイント・自転車ショップ・道の駅などを地図上に登録・共有できます。他のサイクリストが登録したスポットを地図で探したり、チェックインしてランクを競ったりすることもできます。',
      },
      {
        question: 'マップで特定の場所に移動するには？',
        answer:
          'マップ画面右上の虫眼鏡アイコンをタップすると、地名・住所の検索欄が展開されます。2文字以上入力すると候補が表示されるので、目的の場所を選択するとマップがその場所に移動します。',
      },
      {
        question: 'ログインしないと使えませんか？',
        answer:
          'スポットの閲覧と地図の参照はログインなしでできます。チェックイン・いいね・スポット登録・コメントなど投稿系の操作にはログインが必要です。',
      },
      {
        question: '無料で使えますか？',
        answer: 'はい、RideHubは完全無料でご利用いただけます。',
      },
    ],
  },
  {
    title: 'ユーザー',
    items: [
      {
        question: 'ユーザーランクの種類は？',
        answer:
          'チェックインランクとスポットメイカーランクの2種類があります。チェックインランクは累計チェックイン数、スポットメイカーランクはスポット登録や写真投稿などの貢献度をもとに決まります。どちらもLv1〜Lv5の5段階です。',
      },
      {
        question: 'チェックインランクの種類と算出基準は？',
        answer:
          '累計チェックイン数に応じて自動的に昇格します。\n\n・Lv1 ビギナー：1回以上\n・Lv2 ライダー：30回以上\n・Lv3 トラベラー：100回以上\n・Lv4 エクスプローラー：200回以上\n・Lv5 ロードマスター：500回以上\n\nチェックインするたびにリアルタイムで更新されます。',
      },
      {
        question: 'スポットメイカーランクの種類と算出基準は？',
        answer:
          'スポット登録（+10点）・写真投稿（+5点）で積み上がるスコアと、全ユーザーの中での相対順位（パーセンタイル）の両方を満たすと昇格します。\n\n・Lv1 ルーキー：スコア10以上\n・Lv2 マーカー：スコア100以上 かつ 上位60%以内\n・Lv3 アドバイザー：スコア200以上 かつ 上位30%以内\n・Lv4 ナビゲーター：スコア500以上 かつ 上位10%以内\n・Lv5 マイスター：スコア1000以上 かつ 上位1%以内\n\nランクは毎週月曜0:00（JST）にバッチ再計算されます。',
      },
      {
        question: 'ニックネームを変更できますか？',
        answer: 'プロフィール画面の「プロフィール編集」からニックネームを変更できます。',
      },
      {
        question: '退会するとデータはどうなりますか？',
        answer:
          '退会すると登録したスポット・チェックイン・いいね・コメントなどのデータが削除されます。削除されたデータは復元できませんのでご注意ください。',
      },
      {
        question: 'フォロー機能とは何ですか？',
        answer:
          '他のユーザーをフォローすると、タイムラインの「フォロー中」タブでその人のチェックイン・スポット登録・写真投稿をまとめて確認できます。仲間の活動状況を把握するのに便利です。\n\nフォローは相手の承認なしに行えます。プロフィール画面の「フォロー」ボタンからフォロー/解除できます。',
      },
      {
        question: 'フォロワーやフォロー中の一覧を確認するには？',
        answer:
          'プロフィール画面のフォロワー数・フォロー中数をタップすると、それぞれの一覧が表示されます。一覧に表示されたユーザー名をタップするとそのユーザーのプロフィールに移動します。',
      },
      {
        question: 'ダイレクトメッセージ（DM）を送るには？',
        answer:
          'メッセージを送りたいユーザーのプロフィール画面を開き、「ダイレクトメッセージ」リンクをタップします。メッセージ入力欄にテキストを入力して送信ボタンを押すか、Enterキーで送信できます。\n\n送受信したメッセージはボトムナビの封筒アイコンから一覧を確認できます。未読メッセージがある場合はバッジで件数が表示されます。',
      },
      {
        question: 'DMで現在地を送るには？',
        answer:
          'メッセージ入力欄の下にある「現在地を送る」ボタンをタップすると、現在地の地図カードが送信されます。受け取った相手はカードをタップするとGoogleマップが開き、自転車ルートのナビを起動できます。\n\n位置情報の許可が必要です。',
      },
      {
        question: 'DM通知を受け取るには？',
        answer:
          'プロフィール画面の「アカウント」→「通知設定」で「ダイレクトメッセージ」の通知をONにしてください。プッシュ通知も有効にしていると、新着メッセージ時にプッシュ通知が届きます。',
      },
      {
        question: 'DMのメッセージはいつまで保存されますか？',
        answer:
          'メッセージは送受信から90日間保存されます（システム設定により変更される場合があります）。古いメッセージは自動的に削除されます。',
      },
      {
        question: 'ユーザーをブロックするには？',
        answer:
          '会話画面（DM）右上の「…」ボタンをタップして「ブロック」を選択してください。確認後にブロックが実行されます。\n\nブロックすると以下のようになります。\n・メッセージ一覧から相手の会話が非表示になる\n・相手からのDM送信がブロックされる（双方向）',
      },
      {
        question: 'ブロックを解除するには？',
        answer:
          'プロフィール画面の「アカウント」→「通知設定」→「ブロックリスト」を開くと、ブロック中のユーザー一覧が表示されます。解除したいユーザーの「ブロック解除」ボタンをタップすると解除されます。',
      },
      {
        question: 'ブロックすると相手に通知されますか？',
        answer: 'いいえ、ブロックしても相手には通知されません。',
      },
    ],
  },
  {
    title: 'スポット',
    items: [
      {
        question: 'スポットとは何ですか？',
        answer:
          'サイクリストが地図上に登録した場所の情報です。自転車ショップ・絶景スポット・道の駅・カフェ・温泉など、自転車で訪れる価値のある場所を登録できます。',
      },
      {
        question: 'チェックインとは何ですか？',
        answer:
          'スポットの近くにいる状態で「チェックイン」ボタンを押すことで、訪問記録を残せる機能です。チェックイン数が増えるとスポットのランクが上がり、自分のチェックイン実績としても記録されます。',
      },
      {
        question: 'チェックインするには何が必要ですか？',
        answer:
          'ログインと位置情報の許可が必要です。スポットから約100m以内にいる場合にチェックインできます。',
      },
      {
        question: '同じスポットに毎日チェックインできますか？',
        answer:
          'はい、同じスポットに何度でもチェックインできます。チェックインするたびにスポットのランクスコアと自分のチェックイン実績に反映されます。',
      },
      {
        question: 'いいねとは何ですか？',
        answer:
          '気に入ったスポットに「いいね」を送る機能です。いいね数が多いスポットはランキングで上位に表示されやすくなります。',
      },
      {
        question: 'いいねは何回でもできますか？',
        answer:
          '1つのスポットに対して1回のみいいねできます。もう一度タップするといいねを取り消せます。',
      },
      {
        question: 'いいねに位置情報の制限はありますか？',
        answer:
          'いいねには位置情報は不要です。スポット詳細ページから場所に関わらずいいねできます。',
      },
      {
        question: 'いいねとチェックインの違いは何ですか？',
        answer:
          'チェックインは「実際に訪れた記録」で、現地に行かないとできません。いいねは「お気に入り登録」のようなもので、どこからでもできます。',
      },
      {
        question: 'スポットを登録するには？',
        answer:
          'ログイン後、マップ画面の「現在地を登録」ボタンからスポットを追加できます。スポットの場所は現在地（GPS）が自動的に使われるため、実際にその場所にいないと登録できません。訪れたタイミングでその場で登録しましょう。スポット名とカテゴリは必須項目です。',
      },
      {
        question: 'どのような場所を登録すべきですか？',
        answer:
          '自転車で訪れる価値のある場所ならなんでも構いません。例えば、絶景の峠・気持ちいい海沿いの道・穴場の道の駅・おすすめの自転車ショップ・サイクリストが集まるカフェなどです。個人宅や私有地は登録しないようにお願いします。',
      },
      {
        question: 'カテゴリの種類は？',
        answer:
          'バイクショップ・グルメ/カフェ・コンビニ・公園/道の駅・撮影スポット・温泉・駐車場・観光スポット・注意が必要な場所・その他の10種類があります。',
      },
      {
        question: 'タグは何個まで付けられますか？',
        answer: '現在は決まったタグの中から選択する形式です。複数選択できます。',
      },
      {
        question: 'スポットの編集・削除はできますか？',
        answer:
          '自分が登録したスポットのみ編集・削除できます。スポット詳細ページに「スポットを編集」「スポットを削除」ボタンが表示されます。',
      },
      {
        question: '写真は何枚まで投稿できますか？',
        answer:
          '1スポットにつき最大10枚まで写真を投稿できます。1回のアップロードで最大3枚まで選択できます。',
      },
      {
        question: '投稿した写真を削除できますか？',
        answer:
          '自分がアップロードした写真のみ削除できます。写真をタップするとライトボックスが開き、そこから削除できます。',
      },
      {
        question: 'コメントを削除できますか？',
        answer:
          '自分が投稿したコメントのみ削除できます。コメントの横にある削除ボタンをタップすると確認ダイアログが表示され、確認後に削除されます。',
      },
      {
        question: 'コメントに返信できますか？',
        answer:
          'はい。コメントの下にある「返信」ボタンをタップするとインライン返信フォームが表示されます。返信はコメントの下にスレッド形式で表示されます。なお、返信への返信（ネスト）はできません。',
      },
      {
        question: 'ブックマーク機能とは何ですか？',
        answer:
          'スポット詳細画面の「ブックマーク」ボタンでスポットを保存できます。保存したスポットはプロフィール画面の「ブックマーク」から一覧で確認できます。\n\nブックマークはログインが必要です。何件でも保存できます。',
      },
      {
        question: 'コメントに返信が来たとき通知されますか？',
        answer:
          'はい。プッシュ通知を許可している場合、自分のコメントに返信があるとプッシュ通知が届きます。通知をタップするとスポット詳細のコメント欄が開き、該当の返信まで自動的にスクロールされます。\n\nプッシュ通知の許可・設定はプロフィール画面の「アカウント」→「通知設定」からできます。',
      },
      {
        question: 'スポットランクとは何ですか？',
        answer:
          'チェックイン数といいね数をもとに算出されるスポットの人気度スコアです。\n\nスコア = チェックイン数×1点 + いいね数×2点\n\nスコアに応じてブロンズ・シルバー・ゴールド・プラチナの4段階でランクが付きます。\n\n・ブロンズ：10点以上\n・シルバー：50点以上\n・ゴールド：200点以上\n・プラチナ：1000点以上\n\n星の数（0〜5）で視覚的に表示されます。',
      },
      {
        question: 'スポットランクはいつ更新されますか？',
        answer:
          'スコア自体はチェックインやいいねのたびにリアルタイムで更新されます。ブロンズ/シルバーなどのランク判定は毎日深夜2:00（JST）のバッチ処理で再計算されます。',
      },
    ],
  },
  {
    title: 'ユーザーランキング',
    items: [
      {
        question: 'ユーザーランキングの種類は？',
        answer:
          'カテゴリと期間の組み合わせで見ることができます。\n\n【カテゴリ】\n・チェックインランキング：期間内のチェックイン数\n・スポットメイカーランキング：期間内のスポット登録数\n\n【期間】\n・週間：前週（月〜日）の確定ランキング\n・月間：前月の確定ランキング\n・年間：前年の確定ランキング\n・累計：全期間の合計（リアルタイム集計）',
      },
      {
        question: 'ユーザーランキングはいつ更新されますか？',
        answer:
          '週間・月間・年間ランキングは「前期間の確定結果」を表示しています。期間が終わったタイミングで自動集計されます。\n\n・週間：毎週月曜 0:05（JST）に前週分を集計\n・月間：毎月1日 0:05（JST）に前月分を集計\n・年間：毎年1月1日 0:05（JST）に前年分を集計\n\n集計期間はランキング画面上部に表示されます。\n\n累計ランキングのみリアルタイム集計で、チェックインやスポット登録が即座に反映されます。',
      },
    ],
  },
  {
    title: '技術的な質問',
    items: [
      {
        question: 'アプリとしてホーム画面に追加するには？',
        answer:
          'iOSの場合はSafariで開き、共有ボタン →「ホーム画面に追加」を選択してください。Androidの場合はChromeで開き、メニュー →「ホーム画面に追加」を選択してください。ホーム画面からアプリのように起動できます。',
      },
      {
        question: 'プッシュ通知を受け取るには？',
        answer:
          'プロフィール画面の「アカウント」→「通知設定」をタップすると通知許可のリクエストが表示されます。「通知を有効にする」を選択すると、プッシュ通知を受け取れるようになります。\n\n通知設定画面では以下の通知種別をON/OFFできます。\n・ダイレクトメッセージ\n・自分のスポットへのコメント\n・コメント返信\n・ランキング更新\n・ブックマーク新着\n\n現在はAndroid（Chrome）に対応しています。iOSはSafari 16.4以降でホーム画面に追加した状態で対応しています。\n\n一度「許可しない」を選んだ場合は、ブラウザの設定（サイトの設定 → 通知）から手動で許可を変更してください。',
      },
      {
        question: '位置情報の許可が必要ですか？',
        answer:
          'チェックイン機能とスポット登録（現在地の自動取得）には位置情報の許可が必要です。地図の閲覧やスポット一覧の参照は位置情報なしでもできます。ブラウザの設定から許可の変更ができます。',
      },
      {
        question: 'オフラインでも使えますか？',
        answer:
          'オフライン時はスポットの閲覧・登録・チェックインなどの機能は使えません。インターネット接続が必要です。',
      },
    ],
  },
  {
    title: 'マナー・安全について',
    items: [
      {
        question: '荒らしユーザーや不適切な写真を見つけたらどうすればいい？',
        answer:
          'スポット詳細ページの「通報する」ボタン、または写真の通報ボタンからご報告ください。コメントにも通報ボタンがあります。確認の上、適切に対応します。\n\nスパムや不要なDMを送ってくるユーザーについては、会話画面の「…」メニューからブロックすることでメッセージ一覧から非表示にできます。',
      },
      {
        question: '通報するとどうなりますか？',
        answer:
          '管理者が内容を確認し、ガイドライン違反と判断した場合はコンテンツの削除やアカウントの停止などの対応を行います。通報者の情報は相手には通知されません。',
      },
    ],
  },
];
